import axios, { AxiosError } from 'axios';
import get from 'lodash.get';
import { CLEARTAX_DOMAIN } from './constants';
import { uncaughtApiError } from './error';

const finfoAInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_FINFO_ENDPOINT,
});
finfoAInstance.interceptors.response.use(
  (res) => {
    return Promise.resolve(get(res, 'data', null));
  },
  (err) => {
    if (!err.response || !err.response.status || err.response.status >= 500) {
      uncaughtApiError(err, err.response?.status);
    }
    return Promise.reject(
      get(err, 'response.data.errorResponse', { message: '', code: '' })
    );
  }
);

const cleartaxInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_CT_ENDPOINT,
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
  },
});

export const bifrostLayer = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BIFROST_ENDPOINT,
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'content-type': 'application/json',
  },
});
cleartaxInstance.interceptors.response.use(
  (res) => {
    return Promise.resolve(get(res, 'data', null));
  },
  (err) => {
    if (!err.response || !err.response.status || err.response.status >= 500) {
      uncaughtApiError(err, err.response?.status);
    }
    return Promise.reject(
      get(err, 'response.data.message', { message: '', code: '' })
    );
  }
);
bifrostLayer.interceptors.response.use(
  (res) => {
    return Promise.resolve(get(res, 'data', null));
  },
  (err) => {
    if (!err.response || !err.response.status || err.response.status >= 500) {
      uncaughtApiError(err, err.response?.status);
    }
    return Promise.reject(
      get(err, 'response.data.message', { message: '', code: '' })
    );
  }
);

const appInstance = axios.create({
  baseURL: CLEARTAX_DOMAIN,
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
  },
  responseType: 'blob',
});

const mpBackend = axios.create({
  baseURL: process.env.NEXT_PUBLIC_MP_BE_ENDPOINT,
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
  },
});

const ticketServiceBackend = axios.create({
  baseURL: process.env.NEXT_PUBLIC_TICKETS_BACKEND_DOMAIN,
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
  },
});

const businessHiearchy = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BUSINESS_HIERARCHY,
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
    'Accept': 'application/json',
    'x-workspace-id': '2',
    'x-cleartax-product': 'CONSUMER_ITR',

    'Cookie':
      'sid=1.300eed90-ff16-4aed-b71c-8139aa9361b3_9c99cc979e8099639105d96b5b5fb051dcb5897797f5cd5533524205ceda0863',
  },
});

businessHiearchy.interceptors.response.use(
  (res) => {
    return Promise.resolve(get(res, 'data', null));
  },
  (err): Promise<TMPBackendError> => {
    if (!err.response || !err.response.status || err.response.status >= 500) {
      uncaughtApiError(err, err.response?.status);
    }
    const mpBackendError = get(err, 'response.data', { message: '', code: '' });
    return Promise.reject({ ...mpBackendError, errorObj: err });
  }
);
export type TtransformedPromise<T> = Promise<void | T>;

export type TMPBackendError = {
  message?: string;
  code?: string;
  errorObj: AxiosError;
  error?: 'plan not exist';
  context?: null;
  description?: 'plan not found';
};

mpBackend.interceptors.response.use(
  (res) => {
    return Promise.resolve(get(res, 'data', null));
  },
  (err): Promise<TMPBackendError> => {
    if (!err.response || !err.response.status || err.response.status >= 500) {
      uncaughtApiError(err, err.response?.status);
    }
    const mpBackendError = get(err, 'response.data', { message: '', code: '' });
    return Promise.reject({ ...mpBackendError, errorObj: err });
  }
);

ticketServiceBackend.interceptors.response.use(
  (res) => {
    return Promise.resolve(get(res, 'data', null));
  },
  (err): Promise<TMPBackendError> => {
    if (!err.response || !err.response.status || err.response.status >= 500) {
      uncaughtApiError(err, err.response?.status);
    }
    const mpBackendError = get(err, 'response.data', { message: '', code: '' });
    return Promise.reject({ ...mpBackendError, errorObj: err });
  }
);

export {
  finfoAInstance,
  mpBackend,
  cleartaxInstance,
  businessHiearchy,
  appInstance,
  ticketServiceBackend,
};
